import { render, staticRenderFns } from "./CleanApp.vue?vue&type=template&id=4db505e8"
import script from "./CleanApp.vue?vue&type=script&lang=js"
export * from "./CleanApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports